export default {
  full_menu: 'Hele menuen',
  free: 'GRATIS',
};
